module.exports = __webpack_public_path__ + "static/media/Join Now.d5474003.svg";